var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5 101C78.8381 101 101 78.8381 101 51.5C101 24.1619 78.8381 2 51.5 2C24.1619 2 2 24.1619 2 51.5C2 78.8381 24.1619 101 51.5 101Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25093
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.32 41.3998H69.6C72.02 41.3998 74 43.3798 74 45.7998V65.5998C74 68.0198 72.02 69.9998 69.6 69.9998H34.4C31.98 69.9998 30 68.0198 30 65.5998V45.7998C30 43.3798 31.98 41.3998 34.4 41.3998H39.68C40.406 41.3998 41.1874 40.8366 41.4176 40.148L42.7824 36.052C43.0117 35.363 43.794 34.7998 44.52 34.7998H59.48C60.206 34.7998 60.9874 35.363 61.2176 36.0516L62.5824 40.1476C62.8117 40.8366 63.594 41.3998 64.32 41.3998ZM45.4 54.5998C45.4 50.9557 48.3546 47.9998 52 47.9998C55.6445 47.9998 58.6 50.9557 58.6 54.5998C58.6 58.2452 55.6445 61.1998 52 61.1998C48.3546 61.1998 45.4 58.2452 45.4 54.5998ZM52 65.5998C45.9249 65.5998 41 60.6749 41 54.5998C41 48.5252 45.9249 43.5998 52 43.5998C58.0742 43.5998 63 48.5252 63 54.5998C63 60.6749 58.0742 65.5998 52 65.5998ZM66.52 47.3367C66.52 48.1877 67.2099 48.8767 68.06 48.8767C68.9105 48.8767 69.6 48.1877 69.6 47.3367C69.6 46.4866 68.911 45.7967 68.06 45.7967C67.2099 45.7967 66.52 46.4866 66.52 47.3367Z",
    fill: "#030104"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 103,
    height: 103,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.262745 0 0 0 0 0.4 0 0 0 0 0.462745 0 0 0 0.501217 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.81797903389f1d609710c28dc2cc2230.svg";
export { ForwardRef as ReactComponent };